import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ClubIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="#001A19"
      title={t`Club`}
      {...props}
    >
      <G clipPath={`url(#${clipPathId})`}>
        <Path
          fill="currentColor"
          d="M10.972 1.669a.8.8 0 0 1 1.28.738l-.49 3.755a.8.8 0 0 0 .34.762l3.118 2.15a.8.8 0 0 1-.307 1.445l-3.723.695a.8.8 0 0 0-.62.558l-1.08 3.63a.8.8 0 0 1-1.47.154L6.21 12.23a.8.8 0 0 0-.722-.417l-3.786.093a.8.8 0 0 1-.6-1.35l2.602-2.75a.8.8 0 0 0 .173-.816L2.617 3.42a.8.8 0 0 1 1.098-.989l3.42 1.626a.8.8 0 0 0 .83-.087l3.007-2.301Z"
        />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
